class InfiniteScroll {
  constructor() {
    this.container = document.getElementById('product-grid');
    this.paginationContainer = document.querySelector('.pagination-wrapper'); // Ajusté pour Dawn
    this.sentinel = document.getElementById('infinite-scroll-trigger');
    
    if (!this.container || !this.sentinel) return;

    this.initObserver();
  }

  initObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isLoading) {
          this.loadMore();
        }
      });
    }, { rootMargin: '400px' }); // Charge 400px avant d'arriver en bas

    observer.observe(this.sentinel);
  }

  async loadMore() {
    const nextLink = document.querySelector('a.pagination__item--next');
    if (!nextLink) return;

    this.isLoading = true;
    this.sentinel.innerHTML = '<div class="loading-overlay__spinner" style="display:block; margin: 20px auto; width:30px;"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';

    try {
      const response = await fetch(nextLink.href);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      
      const newProducts = doc.querySelectorAll('#product-grid .grid__item');
      const newPagination = doc.querySelector('.pagination-wrapper');

      // Ajouter les nouveaux produits
      newProducts.forEach(product => this.container.appendChild(product));

      // Mettre à jour le lien de pagination caché pour la page suivante
      if (this.paginationContainer && newPagination) {
        this.paginationContainer.innerHTML = newPagination.innerHTML;
      } else if (!newPagination) {
        this.sentinel.remove(); // Plus de produits à charger
      }
    } catch (error) {
      console.error("Erreur chargement infini:", error);
    } finally {
      this.isLoading = false;
      if (document.getElementById('infinite-scroll-trigger')) {
        this.sentinel.innerHTML = ''; 
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('/collections/')) {
    new InfiniteScroll();
  }
});